"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LightningOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var LightningOutlineSVG = function LightningOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.7 30a1.434 1.434 0 0 1-1.42-1.61l.99-8.66H8.1c-.54 0-1.03-.3-1.27-.79-.24-.47-.2-1.04.1-1.48l10.2-14.84c.38-.55 1.07-.77 1.69-.52.61.24.98.86.9 1.51l-.99 8.66h5.17c.54 0 1.03.3 1.27.79.24.47.2 1.04-.1 1.48L14.86 29.39c-.27.4-.71.62-1.17.62l.01-.01zM8.92 17.87h4.88c.4 0 .78.17 1.05.47.26.3.39.69.35 1.09l-.85 7.45 8.75-12.73h-4.88c-.4 0-.78-.17-1.05-.47-.26-.3-.39-.69-.35-1.09l.85-7.45-8.75 12.73z",
    stroke: "none"
  }));
};
exports.LightningOutlineSVG = LightningOutlineSVG;
LightningOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LightningOutlineSVG);
exports.default = _default;